import axios from 'axios'
import qs from 'qs'
import { message } from 'antd'
const crypto = require('crypto')

// 随机字符串
const randomstr = function () {
  var str = '0123456789' + 'abcdefghijklmnopqrstuvwxyz' + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  var str2 = ''
  for (var i = 0; i < 16; i++) {
    str2 = str2 + str.substr(Math.floor(Math.random() * ((str.length - 1) + 1)), 1)
  }
  return str2
}

export function ajaxApi (url, params, errcallback = () => {}, token = '') {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      token: token || window.localStorage.getItem('token') || '',
      requestSource: 'cebianlan'
    },
    withCredentials: false
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
          } else {
            message.error(res.response.data.error_msg || res.response.data.Message || res.response.data.message || res.response.data.errorMsg)
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}
export function ajaxApiGet (url, params, errcallback = () => {}, token = '') {
  return axios({
    method: 'get',
    url: url,
    params: params,
    headers: {
      token: token || window.localStorage.getItem('token') || '',
      requestSource: 'cebianlan'
    },
    withCredentials: false
  })
    .catch(function (res) {
      if (res.response) {
        if (res.response.status !== 200) {
          if (res.response.status === 401 || res.response.data === '认证失败') {
            message.error('登录信息失效，请重新登录')
            window.location.href = '/login'
            // if (errcallback) {
            //   errcallback()
            // }
          } else {
            message.error(res.response.data.error_msg || res.response.data.Message)
          }
          errcallback(res)
        }
      } else {
        errcallback(res)
        if (res.message) {
          message.error(res.message)
        }
      }
      throw res
    })
}
export function uploadApi (url, formdata) {
  let config = {
    headers: {'Content-Type': 'multipart/form-data'}
  }
  return axios.post(url, formdata, config)
}
export function downloadApi (url, param, filename) {
  // const form = this.getSearchForm() // 要发送到后台的数据
  return axios({ // 用axios发送post请求
    method: 'post',
    url: url, // 请求地址
    data: param, // 参数
    responseType: 'blob', // 表明返回服务器返回的数据类型,
    headers: {
      token: window.localStorage.getItem('token') || '',
      requestSource: 'cebianlan'
    }
  }).then((res) => { // 处理返回的文件流
    const content = res.data
    const blob = new Blob([content])

    const fileName = filename
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  })
  // let config = {
  //   headers: {
  //     token: window.localStorage.getItem('token') || ''
  //   }
  // }
  // return axios.post(url, param, config)
}
export function ajaxApiToken (url, token, params, ContentType = 'application/json') {
  const hash = crypto.createHash('md5')
  var timestamp = parseInt(new Date() / 1000)
  var noncestr = randomstr()
  hash.update('noncestr=' + noncestr + '&')
  hash.update('timestamp=' + timestamp + '&')
  hash.update('token=' + token)
  var userMd5 = hash.digest('hex').toUpperCase()
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': ContentType,
      timestamp: timestamp,
      noncestr: noncestr,
      signature: userMd5,
      requestSource: 'cebianlan'
    },
    withCredentials: false
  }).catch(function (res) {
    if (res.response) {
      if (res.response.status !== 200) {
        if (res.response.status === 401 || res.response.data === '认证失败') {
          message.error('登录信息失效，请重新登录')
          window.location.href = '/login'
        } else {
          message.error(res.response.data.error_msg || res.response.data.Message)
        }
      }
    } else {
      if (res.message) {
        message.error(res.message)
      }
    }
    throw res
  })
}

export function ajaxFromdataPost (url, token, params, ContentType = 'application/x-www-form-urlencoded') {
  return axios.post(url, qs.stringify(params), {
    headers: {
      'Content-Type': ContentType,
      token,
      requestSource: 'cebianlan'
    }
  })
}



// WEBPACK FOOTER //
// ./src/server/index.js